import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/ct'
const secureResource = hubbleAPI + 'secure/public/ct'
export default ($axios) => ({

  getCart (cartID) {
    return $axios.get(`${resource}/get-cart/${cartID}`)
  },

  createCart () {
    return $axios.post(`${resource}/create-cart`, {})
  },
  createCartOrder (cartID, paymentReference) {
    const config = {
      headers: {
        paymentRef: paymentReference,
        cartID
      }
    };
    return $axios.post(`${secureResource}/create-shop-order`, {
      cartID,
      paymentReference

    }, config)
  },
  loadOrCreateCart (cartID) {
    if (cartID) {
      return $axios.post(`${resource}/load-create-cart/${cartID}`, {})
    } else {
      return $axios.post(`${resource}/load-create-cart`, {})
    }
  },

  addCartItem (cartID, payload, channelSplit) {
    if (channelSplit !== null) {
      return $axios.post(`${secureResource}/add-cart-item/${cartID}/${channelSplit}`, payload)
    } else {
      return $axios.post(`${secureResource}/add-cart-item/${cartID}`, payload)
    }
  },
  update (id, payload) {
    return $axios.post(`${resource}/${id}`, payload)
  },
  deleteCart(cartID) {
    return $axios.delete(`${resource}/delete-cart/${cartID}`)
  },
  emptyCart(cartID) {
    return $axios.delete(`${resource}/empty-cart/${cartID}`)
  },
  deleteCartGroupItem(payload) {
    return $axios.delete(`${resource}/delete-cart-item`, {
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        ...payload
      }
    })
  }
})
